import Head from "next/head";
import { useSelector } from "react-redux";
import { END } from "redux-saga";

import OfficeListing from "../../src/components/pages/office/Officelisting";

import { getAllCMS } from "../../src/redux/cms/CMSActions";
import { wrapper } from "../../src/config/Store";
import Routes from "../../src/routes/Routes";
import constants from "../../src/utils/Constants";
import {
  officeListingWebPageSchema
} from "../../GO-Bermondsey_Schema";

const { CMS_TYPES, CMS_PAGES } = constants;

const nextOfficeListing = () => {
  const mPageDetails = useSelector(({ cms }) => {
    const boardKey = JSON.stringify({
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.OFFICE_LIST,
    });

    const boards = cms.boards;
    const mPageDetailsId = boards[boardKey]?.list?.[0];

    return cms.cmsMap[mPageDetailsId] || {};
  });

  return (
    <>
      <Head>
        {/* <title>Office listings of Coworking space - Go Bermondsey</title>
        <meta
          name="description"
          content="Looking for a private flexible workspace in London with flexible desks, meeting rooms, and dedicated seats? Check out the coworking office space by Go Bermondsey."
        /> */}
        <title>{mPageDetails?.name || ""}</title>
        <meta name="description" content={mPageDetails?.description || ""} />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link rel="canonical" href={`${Routes?.domain}${Routes?.office}`} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: officeListingWebPageSchema,
          }}
        />

      </Head>
      <OfficeListing />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const cmsState = store.getState().cms;

    const pageDetailsParams = {
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.OFFICE_LIST,
    };
    const pageDetailsBoard = cmsState.boards[JSON.stringify(pageDetailsParams)];
    if (!pageDetailsBoard) {
      store.dispatch(getAllCMS(pageDetailsParams));
    }

    const officeListParams = {
      type: CMS_TYPES.PAGE_FOLD,
      page_name: CMS_PAGES.OFFICE_LIST,
    };
    const officeListBoard = cmsState.boards[JSON.stringify(officeListParams)];
    if (!officeListBoard) {
      store.dispatch(getAllCMS(officeListParams));
    }

    const testimonialsParams = { type: CMS_TYPES.TESTIMONIAL };
    const testimonialsBoard = cmsState.boards[JSON.stringify(testimonialsParams)];
    if (!testimonialsBoard) {
      store.dispatch(getAllCMS(testimonialsParams));
    }

    store.dispatch(END);
    await store.sagaTask.toPromise();
  }
);

export default nextOfficeListing;
